import { render, staticRenderFns } from "./InvestigationReferrals.vue?vue&type=template&id=685b29b6&scoped=true"
import script from "./InvestigationReferrals.vue?vue&type=script&lang=js"
export * from "./InvestigationReferrals.vue?vue&type=script&lang=js"
import style0 from "./InvestigationReferrals.vue?vue&type=style&index=0&id=685b29b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685b29b6",
  null
  
)

export default component.exports